export default "__VITE_ASSET__DnCPC_Fi__"